import { Box, Typography } from '@mui/material';
import config from 'config/config';
import { PAYPAL_CONFIG } from 'config/paypal-config';
import React, { FC, useMemo } from 'react';
import { useStyles } from './WithdrawRequestInstructions.styles';

export const WithdrawRequestInstructions: FC = () => {
  const { classes } = useStyles();

  const firstItem = useMemo(() => {
    if (config.isPaypalLinkEnabled) {
      return (
        <li>
          <Typography mb={1}>Link your PayPal account if not done yet.</Typography>

          <ul>
            <li>
              {PAYPAL_CONFIG.isInternationalWithdrawEnabled
                ? 'NOTE: Only verified accounts can be linked'
                : `NOTE: ${PAYPAL_CONFIG.withdrawAllowedCountryNames} and verified accounts are
                supported for now.`}
            </li>
          </ul>
        </li>
      );
    }

    return (
      <li>
        <Typography mb={1}>Enter your PayPal email address.</Typography>
        <ul>
          <li>
            <Typography>
              WARNING: Double check the email address, otherwise funds may be lost.
            </Typography>
          </li>
        </ul>
      </li>
    );
  }, []);

  return (
    <Box className={classes.root}>
      <ol className={classes.list}>
        {firstItem}
        <li>
          <Typography>Crypto funds will be debited from your OKLP wallet now.</Typography>
        </li>
        <li>
          <Typography mb={1}>
            Funds will arrive to your PayPal account. It may take up to 60 hours.
          </Typography>
          <ul>
            <li>
              <Typography>NOTE: We support only USD as destination currency.</Typography>
            </li>
          </ul>
        </li>
      </ol>
    </Box>
  );
};
